<template>
  <div class="row u-justify-content-center u-margin-top-large">
    <div
      class="es-xs-12 es-sm-6 es-md-4 es-lg-3"
      v-for="item in items"
      :key="item.label"
      @click="SET_TYPE(item)"
    >
      <div class="o-card u-text-align-center u-hover-select">
        <div>
          {{ $t("ehouseDoubleCalculating.title") }}
        </div>
        <div class="u-margin-top-small">(Double)</div>
        <h1 class="u-font-size-huge u-color-primary">
          {{ item.label }}
        </h1>
        <div>{{ $t("common.choose") }} <i class="icofont-arrow-right"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import { EhouseDoubleCalculatingTypeList } from "@/enums/Calculatings/EdoubleCalculatingTypes";
export default {
  data() {
    return {
      items: EhouseDoubleCalculatingTypeList,
    };
  },
  methods: {
    SET_TYPE(item) {
      this.$emit("change:type", item.value);
    },
  },
};
</script>

<style></style>
